import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { HsLoadingSpinnerModule } from '@hsetu/ngui-components';

@Component({
  selector: 'kfm-spinner-dialog',
  standalone: true,
  imports: [CommonModule, HsLoadingSpinnerModule],
  templateUrl: './kfm-spinner-dialog.component.html',
  host: { class: 'kfm-spinner-dialog layer-one' },
})
export class KfmSpinnerDialogComponent {
  private readonly _data = inject<{ text: string }>(DIALOG_DATA);

  protected readonly dialogRef = inject<DialogRef<void>>(DialogRef);

  protected get text() {
    return this._data.text;
  }

  constructor() {
    this.dialogRef.disableClose = true;
  }
}
